import type { IFilter } from '@models/Filter'
import type { Query } from '@models/Query'

import { apiClient } from '../../../gateways/api'
import type {
  FetchTeBeoordelen,
  FetchTeBeoordelenFilters,
} from '../types/FetchTeBeoordelen'

export { fetchTeBeoordelen, createFilters, initialState }

const fetchTeBeoordelen = async ({
  query,
}: {
  query: Query<FetchTeBeoordelenFilters>
}): Promise<FetchTeBeoordelen['data']> => {
  const { filters } = query

  const { data } = await apiClient({
    url: '/rest/dashboard/hoofdleiding/werklijst',
    method: 'POST',
    data: { filters: createFilters(filters) },
  })

  return data
}

const createFilters = ({
  organisatie,
  startUitvoeringWeekTot,
  startUitvoeringWeekVan,
  opleverweekVan,
  opleverweekTot,
  verantwoordelijke,
  contactpersoon,
  processtatus,
  typeWerk,
  gebied,
  labels,
  myList,
  gemeente,
}: FetchTeBeoordelenFilters) => {
  const filters: IFilter[] = []

  if (organisatie)
    filters.push({
      name: 'organisatie',
      value: organisatie.label,
      operator: 'eq',
    })

  filters.push({
    name: 'isActive',
    value: true,
    operator: 'eq',
  })

  if (opleverweekVan) {
    filters.push({
      name: 'dueWeek',
      value: opleverweekVan,
      operator: 'gte',
    })
  }

  if (opleverweekTot) {
    filters.push({
      name: 'dueWeek',
      value: opleverweekTot,
      operator: 'lte',
    })
  }

  if (startUitvoeringWeekVan)
    filters.push({
      name: 'searchValues.startUitvoeringWeek',
      value: startUitvoeringWeekVan,
      operator: 'gte',
    })
  if (startUitvoeringWeekTot)
    filters.push({
      name: 'searchValues.startUitvoeringWeek',
      value: startUitvoeringWeekTot,
      operator: 'lte',
    })

  if (verantwoordelijke)
    filters.push({
      name: 'verantwoordelijken',
      value: verantwoordelijke.code,
      operator: 'eq',
    })

  if (processtatus && processtatus.length > 0) {
    filters.push({
      name: 'processtatus',
      value: processtatus,
      operator: 'in',
    })
    filters.push({
      name: 'searchValues.statusText',
      value: processtatus,
      operator: 'in',
    })
  }

  if (Array.isArray(typeWerk) && typeWerk.length > 0) {
    filters.push({
      name: 'searchValues.typeWerk',
      operator: 'in',
      value: typeWerk,
    })
  }
  if (gebied && gebied.length > 0)
    filters.push({
      name: 'gebiedscode',
      value: gebied.map(({ code }) => code),
      operator: 'in',
    })

  if (labels && labels.length > 0)
    filters.push({
      name: 'labels',
      value: labels.map(({ code }) => code),
      operator: 'in',
    })

  if (contactpersoon)
    filters.push({
      name: 'contactpersoon',
      operator: 'eq',
      value: contactpersoon.userid,
    })

  if (myList) {
    filters.push({ name: 'my-list', value: true, operator: 'eq' })
  }

  if (gemeente.length > 0)
    filters.push({
      name: 'searchValues.gemeente',
      value: gemeente,
      operator: 'in',
    })

  return filters
}

const initialState: FetchTeBeoordelen = {
  data: {
    reviewBijlagen: [],
  },
  query: {
    filters: {
      gebied: [],
      labels: [],
      organisatie: null,
      myList: false,
      startUitvoeringWeekTot: '',
      startUitvoeringWeekVan: '',
      verantwoordelijke: null,
      contactpersoon: null,
      opleverweekTot: '',
      opleverweekVan: '',
      processtatus: [],
      typeWerk: [],
      gemeente: [],
    },
  },
}
